const READER_URL = 'http://127.0.0.1:17822';
const START_PROTOCOL = 'eloadmin-acr122u://start';

const wait = milliseconds => new Promise(resolve => {
  setTimeout(resolve, milliseconds);
});

const requestUid = async () => {
  const response = await fetch(`${READER_URL}/uid?timeout=30000`);
  const data = await response.json();
  if (!response.ok || !data.uid) {
    throw new Error(data.message || 'Não foi possível ler o cartão.');
  }
  return data.uid;
};

const startLocalBridge = () => {
  const launcher = document.createElement('iframe');
  launcher.style.display = 'none';
  launcher.src = START_PROTOCOL;
  document.body.appendChild(launcher);
  setTimeout(() => launcher.remove(), 5000);
};

const waitForLocalBridge = async (attempt = 0) => {
  if (attempt >= 12) return false;

  await wait(500);
  try {
    const response = await fetch(`${READER_URL}/health`);
    if (response.ok) return true;
  } catch (error) {
    // Aguarda a inicialização e tenta novamente.
  }

  return waitForLocalBridge(attempt + 1);
};

export async function readAcr122uUid() {
  try {
    return await requestUid();
  } catch (error) {
    if (!(error instanceof TypeError)) throw error;

    startLocalBridge();
    const started = await waitForLocalBridge();
    if (!started) {
      throw new TypeError('O serviço local do leitor não está em execução.');
    }
    return requestUid();
  }
}
